import ProjectProfileDialog from './ProjectProfileDialog';

export default ProjectProfileDialog;
